// Will be replaced during production builds - see prepare.sh
export const BuildVersion = "52e285d";
